import {AfterViewInit, Directive, ElementRef, Optional} from "@angular/core";
import {DxiColumnComponent} from "devextreme-angular/ui/nested";
import * as _ from 'lodash';

@Directive({
    selector: 'dxi-column[displayValue]'
})
export class DxiColumnDisplayValueDirective implements AfterViewInit {

    private readonly dxiColumn: DxiColumnComponent;
    private dataField: string;

    constructor(private elementRef: ElementRef,
                @Optional() dxiColumn: DxiColumnComponent) {
        this.dxiColumn = dxiColumn;
    }

    ngAfterViewInit(): void {
        if (this.dxiColumn) {
            this.dataField = this.dxiColumn.dataField
            this.dxiColumn.calculateCellValue = (event) => {
                let data = _.get(event, this.dataField);
                if (event && typeof (event) == 'object' && !!data) {
                    return data?.getDisplayValue() ? data.getDisplayValue() : ''
                }

                return '';
            }
        }
    };
}